import CustomizationsDataContext from '@/contexts/customizations-data-context';
import { useContext } from 'react';

export const useCustomizationsData = () => {
  return useContext(CustomizationsDataContext);
};
